// extracted by mini-css-extract-plugin
module.exports = {"QuestionText":"QuestionTextOld_QuestionText__1bUBz","AnsDemo":"QuestionTextOld_AnsDemo__2Pwla"};